<template>
  <dashboard
    :results="searchProfile"
    :searching="this.$apollo.queries.searchProfile.loading"
    :loading-profile="loadingProfile"
    @search-profile="handleSearchQuery"
    @display-profile="handleDisplayProfile"
  />
</template>

<script>
import Dashboard from '@/components/permission/Dashboard';
import searchQuery from '@/graphql/permission/searchQuery.gql';

export default {
  name: 'PermissionsDashboardContainer',
  components: {
    Dashboard,
  },
  apollo: {
    searchProfile: {
      client: 'apiv2',
      query: searchQuery,
      debounce: 200,
      variables: {
        query: JSON.stringify({
          identifier: '',
        }),
      },
    },
  },
  data() {
    return {
      loadingProfile: false,
      searchProfile: {
        filteredTotal: 0,
        profiles: [],
      },
    };
  },
  methods: {
    handleDisplayProfile() {
      this.loadingProfile = true;
    },
    handleSearchQuery(query) {
      this.loadingProfile = true;
      this.$apollo.queries.searchProfile.refetch({
        query: JSON.stringify({
          identifier: query,
        }),
      })
        .then(result => {
          const updatedSearchProfile = {
            ...this.searchProfile,
            profiles: result.data.searchProfile.profiles,
            filteredTotal: result.data.searchProfile.filteredTotal,
          };
          this.searchProfile = updatedSearchProfile;
          this.loadingProfile = false;

          if (updatedSearchProfile.filteredTotal === 0 && query !== '') {
            this.$notify({
              type: 'info',
              duration: 2500,
              message: 'No profile meeting the specified criteria found.',
            });
          }
        })
        .catch(error => {
          const errorMessage =
            error.response && error.response.data.errors[0].message
              ? error.response.data.errors[0].message
              : 'Something went wrong while trying to search profile.';
          this.$notify({
            type: 'error',
            message: errorMessage,
          });
          this.loadingProfile = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// PermissionsDashboardContainer.vue?07c00a9f